// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/js/" + chunkId + "." + {"16":"9459a41d","109":"4b2b64a7","189":"0f6f7a25","222":"60cda558","319":"ce5dd821","327":"deb155d4","406":"babb7ed8","420":"cc69bf9a","454":"bdb8728e","506":"86b88b26","940":"9fb97c33"}[chunkId] + ".js";
};